import script from "./TopHeaderFloating.vue?vue&type=script&setup=true&lang=js"
export * from "./TopHeaderFloating.vue?vue&type=script&setup=true&lang=js"

const cssModules = {}
import style0 from "./TopHeaderFloating.vue?vue&type=style&index=0&id=3f1f09cc&module=floatingTopHeader&lang=css"
cssModules["floatingTopHeader"] = style0
import "./TopHeaderFloating.vue?vue&type=style&index=1&id=3f1f09cc&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules],['__scopeId',"data-v-3f1f09cc"]])

export default __exports__
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QToolbar,QBtn,QSpace,QSeparator});
